import quickDateFormat from '@dyl/utils/quickDateFormat';
import startCase from 'lodash/startCase';

import ObjectPicker from '../../../components/ObjectPicker';
import withProps from '../../../utils/withProps';

const TestPicker = withProps(ObjectPicker, {
    columns: [
        { headerName: 'Test ID', field: 'name', flex: 3, },
        { headerName: 'Updated date/time', field: 'updated_at', flex: 3,
            valueGetter({ value }) {
                return quickDateFormat(value);
            },
        },
        { headerName: 'Status', field: 'status', flex: 2,
            valueGetter({ value }) {
                return startCase(value);
            },
        },
    ],
    getId: g => g.test_group_id,
    getDisplayName: g => g.name,
    searchColumn: 'name',
    DialogProps: {
        maxWidth: 'md',
    },
});

export default TestPicker;